import { memo } from 'react';
import { useAppDispatch } from 'root/src/client/logic/helpers/useStore';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import Confetti from 'react-confetti';
import { Cup, CupSize, CupVariant } from 'root/src/client/web/giveaway/components/Cup';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import displayModal from 'root/src/client/logic/modal/actions/displayModal';
import { giveawayModuleIds } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const GiveawayWonModal = memo(() => {
    const dispatch = useAppDispatch();
    const modal = useModal();
    return (<ModalLayout>
			<div className="absolute left-0 top-0 z-0 w-full h-full overflow-hidden">
				<Confetti numberOfPieces={100}/>
			</div>
			<h1 className="font-bold text-2xl font-mono">Congratulations!</h1>
			<Cup size={CupSize.XL} variant={CupVariant.Gold}/>
			<p className="text-teal font-bold">You have won the Giveaway!</p>
			<p>Remember to claim reward</p>
			<ButtonNew type="button" onClick={() => {
            modal.hide();
            dispatch(displayModal(giveawayModuleIds.REDEEM_MODAL_MODULE_ID, {}));
        }}>
				Select Reward
			</ButtonNew>
		</ModalLayout>);
});
